<template>
  <div class="modal-wrapper" v-if="open">
    <div class="modal-backdrop"></div>
    <div class="modal-inner">
      <div class="edit-popup edit-popup--rental">
        <div class="edit-popup__header">
          <div class="edit-popup__title">
            <div class="edit-popup__title__icon">
              <svg width="1em" height="1em" class="icon icon-list">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use>
              </svg>
            </div>
            <span>Seasons | {{ title }}</span>
          </div>
          <div
            class="edit-popup__close"
            @click="
              seasons.filter((item) => item.edit).length === seasons.length
                ? $emit('close')
                : $emit('notLeavePopupHandler', {
                    handler: clearEdit,
                  })
            ">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>
        <form
          action="javascript:void(0)"
          class="edit-popup__season edit-popup__season--add">
          <div class="edit-popup__season__top">
            <span class="edit-popup__season__title">ADD SEASON</span>
          </div>
          <div
            class="edit-popup__season__add"
            :class="{'edit-popup__season__add--wrap': type === 'flight'}">
            <div class="edit-popup__season__add__name">
              <div class="form-control-group">
                <span class="form-control-label">Name</span>
                <div class="form-control-wrap">
                  <input
                    type="text"
                    Placeholder="Season name"
                    v-model="create"
                    @input="
                      create = $event.target.value.replace(
                        /[^A-Za-z0-9- ]/g,
                        ''
                      )
                    "
                    @focus="
                      $event.target.parentElement.classList.remove('is-error')
                    "
                    class="form-control form-control-name-add" />
                </div>
              </div>
            </div>
            <div
              v-if="type === 'flight'"
              class="form-control-group edit-popup__season__add__name"
              :style="{height: '56.8px'}">
              <span class="form-control-label">Company</span>
              <div
                :class="[
                  'select-wrapper',
                  {
                    'is-active': showCompanySelect,
                    'is-error': companySelectError,
                  },
                ]"
                :style="{width: '100%'}"
                @click="
                  showCompanySelect = !showCompanySelect
                  companySelectError = false
                ">
                <div class="select-trigger select-trigger--width">
                  <span class="select-trigger__name">{{
                    companiesFilter.find((item) => item.active)
                      ? companiesFilter.find((item) => item.active).name
                      : ''
                  }}</span
                  ><span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                  ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                      v-for="item in companiesFilter"
                      :key="item.id"
                      :class="['select-option', {'is-selected': item.active}]"
                      @click="
                        companiesFilter = companiesFilter.map((company) =>
                          item.id === company.id
                            ? {...company, active: true}
                            : {...company, active: false}
                        )
                      ">
                      <span class="select-option__name">{{ item.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-control-datepicker">
              <div class="form-control-group">
                <span class="form-control-label">From</span>
                <div
                  class="form-control-wrap"
                  @click="
                    $event.target.parentElement.parentElement.parentElement
                      .querySelectorAll('.form-control-wrap')
                      .forEach((elem) => elem.classList.remove('is-error'))
                  ">
                  <the-mask
                    type="text"
                    ref="createFrom"
                    class="form-control js-datepicker-single form-control-date-add form-control-date-add-from"
                    :mask="'##.##.####'"
                    placeholder="Date From" />
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-calendar">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="form-control-group">
                <span class="form-control-label">To</span>
                <div
                  class="form-control-wrap"
                  @click="
                    $event.target.parentElement.parentElement.parentElement
                      .querySelectorAll('.form-control-wrap')
                      .forEach((elem) => elem.classList.remove('is-error'))
                  ">
                  <the-mask
                    type="text"
                    ref="createTo"
                    class="form-control js-datepicker-single form-control-date-add form-control-date-add-to"
                    :mask="'##.##.####'"
                    placeholder="Date To" />
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-calendar">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__season__add__submit">
              <button
                type="submit"
                class="btn btn--green"
                @click="createSeason">
                <span>Add</span>
              </button>
            </div>
          </div>
        </form>
        <form
          action="javascript:void(0)"
          class="edit-popup__season edit-popup__season--list">
          <div class="edit-popup__season__top">
            <span class="edit-popup__season__title">SEASONS</span>
            <div class="form-control-wrap">
              <input
                type="text"
                placeholder="Search"
                v-model="search"
                class="form-control-search" />
              <div class="form-control-icon">
                <svg width="1em" height="1em" class="icon icon-search">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                </svg>
              </div>
            </div>
          </div>
          <div class="edit-popup__season__table-inner">
            <div class="edit-popup__season__table">
              <div
                class="edit-popup__season__table__header"
                :class="{
                  'edit-popup__season__table__header--flight':
                    type === 'flight',
                }">
                <div class="edit-popup__season__table__name">
                  <span>Name</span>
                </div>
                <div
                  v-if="type === 'flight'"
                  class="edit-popup__season__table__name">
                  <span>Company</span>
                </div>
                <div class="edit-popup__season__table__from">
                  <span>From</span>
                </div>
                <div class="edit-popup__season__table__to"><span>To</span></div>
              </div>
              <simplebar
                data-simplebar-auto-hide="false"
                class="edit-popup__season__table-wrap edit-popup__season__table-wrap_1">
                <div
                  class="edit-popup__season__table__row"
                  :class="{
                    'edit-popup__season__table__row--flight': type === 'flight',
                  }"
                  v-for="item in seasons"
                  :key="item.id">
                  <div class="edit-popup__season__table__name">
                    <input
                      type="text"
                      :disabled="item.edit"
                      Placeholder="Name"
                      v-model="item.name"
                      @input="
                        item.name = $event.target.value.replace(
                          /[^A-Za-z0-9- ]/g,
                          ''
                        )
                      "
                      class="form-control form-control-name-list" />
                  </div>
                  <div
                    v-if="type === 'flight'"
                    class="edit-popup__season__table__name">
                    <div
                      :class="[
                        'select-wrapper',
                        {
                          'is-active': item.showSelect,
                          'select-wrapper--disabled': item.edit,
                        },
                      ]"
                      :style="{width: '100%'}"
                      @click="item.showSelect = !item.showSelect">
                      <div class="select-trigger select-trigger--width">
                        <span class="select-trigger__name">{{
                          companiesFilter.find(
                            (itm) => itm.id === item.companyId
                          ).name
                        }}</span
                        ><span class="select-trigger__icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-chevron">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                            v-for="cmpn in companiesFilter"
                            :key="cmpn.id"
                            :class="[
                              'select-option',
                              {'is-selected': cmpn.active},
                            ]"
                            @click="
                              companiesFilter = companiesFilter.map((company) =>
                                cmpn.id === company.id
                                  ? {...company, active: true}
                                  : {...company, active: false}
                              )
                            ">
                            <span class="select-option__name">{{
                              cmpn.name
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-datepicker">
                    <div class="form-control-group">
                      <div
                        class="form-control-wrap"
                        @click.capture="
                          $event.target.classList.remove('is-error')
                        ">
                        <the-mask
                          :disabled="item.edit"
                          type="text"
                          :ref="'dateFrom' + item.id"
                          :value="item.dateFrom"
                          :class="[
                            'form-control js-datepicker-single form-control-date-list',
                            'form-control-date-list-from' + item.id,
                          ]"
                          :mask="'##.##.####'"
                          placeholder="Date From" />
                        <div class="form-control-icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group">
                      <div
                        class="form-control-wrap"
                        @click.capture="
                          $event.target.classList.remove('is-error')
                        ">
                        <the-mask
                          :disabled="item.edit"
                          type="text"
                          :ref="'dateTo' + item.id"
                          :value="item.dateTo"
                          :class="[
                            'form-control js-datepicker-single form-control-date-list',
                            'form-control-date-list-to' + item.id,
                          ]"
                          :mask="'##.##.####'"
                          placeholder="Date To" />
                        <div class="form-control-icon">
                          <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="edit-popup__season__table__actions">
                    <button
                      type="button"
                      class="btn btn--edit"
                      @click="
                        !item.edit ? saveSeason({...item}) : false
                        item.edit = !item.edit
                      ">
                      <svg
                        width="1em"
                        height="1em"
                        class="icon icon-edit"
                        v-if="item.edit">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"
                          v-if="item.edit"></use>
                        <!-- <use xlink:href="/images/useful/svg/save.svg" v-if="!item.edit"></use> -->
                      </svg>
                      <svg
                        version="1.1"
                        class="svgbtn"
                        v-if="!item.edit"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M346,422H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,422,346,422z" />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M346,302H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,302,346,302z" />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M346,362H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,362,346,362z" />
                          </g>
                        </g>
                        <g>
                          <g>
                            <rect
                              x="121"
                              width="210"
                              height="130"
                              fill="#fff" />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path
                              d="M507.606,84.394l-80-80C424.793,1.581,420.978,0,417,0h-56v145c0,8.284-6.716,15-15,15H106c-8.284,0-15-6.716-15-15V0H15
                                                        C6.716,0,0,6.716,0,15v482c0,8.284,6.716,15,15,15c4.645,0,475.762,0,482,0c8.284,0,15-6.716,15-15V95
                                                        C512,91.022,510.419,87.207,507.606,84.394z M391,482H121V272h270V482z" />
                          </g>
                        </g>
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="btn btn--remove"
                      @click="
                        $emit('deleteModalHandler', {
                          entity: 'Season',
                          name: item.name,
                          handler: deleteSeason,
                          id: item.id,
                        })
                      ">
                      <svg width="1em" height="1em" class="icon icon-close">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                    <span
                      class="form-control__help-icon tooltip-ic-important"
                      v-if="item.warnings.length">
                      <span class="form-control__help-content">
                        <span v-for="warn in item.warnings" :key="warn.code"
                          >{{ warn.code }} {{ warn.description }}<br
                        /></span>
                      </span>
                      <svg width="1em" height="1em" class="icon icon-close">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                      </svg>
                    </span>
                  </div>
                </div>
              </simplebar>
            </div>
          </div>
          <div class="edit-popup__season__submit">
            <button
              type="submit"
              class="btn btn--green"
              @click="
                seasons.filter((item) => item.edit).length === seasons.length
                  ? $emit('close')
                  : $emit('notLeavePopupHandler', {
                      handler: clearEdit,
                    })
              ">
              <span>Close</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSeasonsType,
  createSeasonsType,
  deleteSeasonsType,
  updateSeasonsType,
} from '@/utilites/api'

import simplebar from 'simplebar-vue'
import Lightpick from 'lightpick'
import {TheMask} from 'vue-the-mask'
export default {
  data() {
    return {
      seasons: [],
      seasonsData: [],
      create: '',
      search: '',
      isEdit: false,
      showCompanySelect: false,
      companySelectError: false,
      companiesFilter: [],
    }
  },
  components: {simplebar, Lightpick, TheMask},
  props: ['open', 'title', 'user', 'type', 'companies'],
  watch: {
    companies() {
      this.companiesFilter = this.companies
    },
    open() {
      if (this.open) {
        this.updateDate()
      }
    },
    search() {
      if (this.search.length === 0) {
        this.seasons = this.seasonsData
      }
      let filtered = this.seasonsData.filter((item) =>
        this.search.length
          ? item.name &&
            item.name.toLowerCase().includes(this.search.toLowerCase())
            ? item
            : false
          : item
      )
      this.seasons = filtered
    },
    seasons() {
      if (
        this.seasons.filter((item) => item.edit).length > this.seasons.length
      ) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
    },
  },
  methods: {
    checkErrorsAdd() {
      if (!this.companiesFilter.find((item) => item.active))
        this.companySelectError = true
      let error = false
      document.querySelectorAll('.form-control-name-add').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      document.querySelectorAll('.form-control-date-add').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      let from = document.querySelectorAll('.form-control-date-add')[0].value
      let to = document.querySelectorAll('.form-control-date-add')[1].value
      if (from && to) {
        from = new Date(
          (+from.split('.')[1]).toString() +
            '.' +
            (+from.split('.')[0]).toString() +
            '.' +
            (+from.split('.')[2]).toString()
        ).getTime()
        to = new Date(
          (+to.split('.')[1]).toString() +
            '.' +
            (+to.split('.')[0]).toString() +
            '.' +
            (+to.split('.')[2]).toString()
        ).getTime()
      }
      if (from > to) {
        document.querySelectorAll('.form-control-date-add').forEach((elem) => {
          elem.parentElement.classList.add('is-error')
          error = true
        })
      }
      return error
    },
    checkErrorsEdit() {
      let error = false
      document.querySelectorAll('.form-control-name-list').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      document.querySelectorAll('.form-control-date-list').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      return error
    },
    checkErrorsUpdated(id) {
      let error = false
      let from = document.querySelector(
        '.form-control-date-list-from' + id
      ).value
      let to = document.querySelector('.form-control-date-list-to' + id).value
      if (from && to) {
        from = new Date(
          (+from.split('.')[1]).toString() +
            '.' +
            (+from.split('.')[0]).toString() +
            '.' +
            (+from.split('.')[2]).toString()
        ).getTime()
        to = new Date(
          (+to.split('.')[1]).toString() +
            '.' +
            (+to.split('.')[0]).toString() +
            '.' +
            (+to.split('.')[2]).toString()
        ).getTime()
      }
      if (from > to) {
        error = true
        document
          .querySelector('.form-control-date-list-from' + id)
          .parentElement.classList.add('is-error')
        document
          .querySelector('.form-control-date-list-to' + id)
          .parentElement.classList.add('is-error')
      } else {
        document.querySelectorAll('.form-control-date-list').forEach((elem) => {
          elem.parentElement.classList.remove('is-error')
        })
      }
      return error
    },
    saveSeason(season) {
      if (!this.checkErrorsEdit() && !this.checkErrorsUpdated(season.id)) {
        updateSeasonsType(this.user.access_token, this.type, {
          id: season.id,
          name: season.name,
          dateFrom: document.querySelector(
            '.form-control-date-list-from' + season.id
          ).value,
          dateTo: document.querySelector(
            '.form-control-date-list-to' + season.id
          ).value,
          companyId: season.companyId,
        })
          .then((res) => {
            this.$emit('confirmed')
          })
          .catch(() => {
            this.updateDate()
            this.$emit('errored')
          })
      }
    },
    createSeason() {
      if (!this.checkErrorsAdd()) {
        const data = {
          name: this.create,
          dateFrom: document.querySelector('.form-control-date-add-from').value,
          dateTo: document.querySelector('.form-control-date-add-to').value,
        }
        if (this.companiesFilter.length)
          data.companyId = this.companiesFilter.find((item) => item.active).id
        createSeasonsType(this.user.access_token, this.type, data)
          .then((res) => {
            this.updateDate()
            this.create = ''
            document.querySelector('.form-control-date-add-from').value = ''
            document.querySelector('.form-control-date-add-to').value = ''
            if (this.companiesFilter.length)
              this.companiesFilter.map((item) => (item.active = false))
            this.$emit('confirmed')
          })
          .catch(() => {
            document
              .querySelectorAll('.form-control-date-add')
              .forEach((elem) => {
                elem.parentElement.classList.add('is-error')
              })
          })
        document.querySelector(
          '.edit-popup__season__table-wrap'
        ).scrollTop = 3000
      }
    },
    deleteSeason(id) {
      deleteSeasonsType(this.user.access_token, this.type, id).then((res) => {
        this.updateDate()
      })
    },
    updateDate() {
      this.companySelectError = false
      getSeasonsType(this.user.access_token, this.type).then((res) => {
        this.seasons = res
          .map((item) => ({...item, edit: true, showSelect: false}))
          .sort((a, b) => (a.dateFrom < b.dateFrom ? -1 : 1))
        this.seasonsData = res
          .map((item) => ({...item, edit: true}))
          .sort((a, b) => (a.dateFrom < b.dateFrom ? -1 : 1))
        document.querySelectorAll('.lightpick').forEach((elem) => {
          elem.remove()
        })
        setTimeout(() => {
          document.querySelectorAll('.js-datepicker-single').forEach((item) => {
            const datePicker = new Lightpick({
              field: item,
              singleDate: true,
              lang: 'en',
              format: 'DD.MM.YYYY',
              startDate: Date.now(),
              onOpen: () => {
                document
                  .querySelectorAll('.lightpick__select-years')
                  .forEach((elem) => {
                    elem.innerHTML = ''
                    for (
                      let index = +new Date().getFullYear() - 2;
                      index < +new Date().getFullYear() + 20;
                      index++
                    ) {
                      let create = document.createElement('option')
                      create.innerHTML = index
                      create.setAttribute('value', index)
                      if (index === new Date().getFullYear()) {
                        create.setAttribute('selected', 'selected')
                      }
                      elem.append(create)
                    }
                  })
              },
            })
          })
        }, 500)
      })
    },
    clearEdit() {
      this.$emit('close')
      this.isEdit = false
    },
  },
}
</script>
